export default __webpack_public_path__ + "static/Tom-Freriks-ef0e7c92518dc2db5ed7c7a92346148b.png";